import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Text,
  VStack,
  Wrap,
  WrapItem,
  useBreakpointValue,
  useTimeout,
  useToast } from
"@chakra-ui/react";
import React, { useRef } from "react";
import {
  getRandomVinMessage,
  getSectionSubjectTree,
  getSectionSubjectTreeV3 } from
"../../network/LearnApiService";
import {
  capitalize,
  isEmptyOrNull,
  isNotEmptyOrNull,
  taskTourData,
  taskTourDataWithoutTasks,
  urlString } from
"../../utils/common-utils";
import {
  getALlTasks,
  getTaskCountAPI,
  startTask } from
"../../api/task-services";
import { status, taskTypes } from "../../utils/LearningPathUtils";
import { useEffect, useState } from "react";

import AssistantImg from "../../assets/ai-tutor/assistant.svg";
import { GET_DATA } from "../../network/graphql/Learn";
import HomeLottie from "../../components/atoms/icons/homeLottie.json";
import Lottie from "react-lottie-player";
import MobileTaskCard from "../../components/molecules/task/MobileTaskCard";
import PaginationComponent from "./PaginationComponent";
import PlainInput from "../ai-tutor/Editor/PlainInput";
import RESOURCES from "../../resourses/RESOURCES";
import SchoolUpdatesPresenter from "../../components/molecules/schoolUpdates/SchoolUpdatesPresenter";
import TaskCard from "../../components/molecules/task/TaskCard";
import accordion_images from "../../utils/accordion/accordion_images";
import styles from "../../components/molecules/ai-tutor/Assistant/assistant.module.css";
import { useLocation, useNavigate } from "@remix-run/react";
import { usePractice } from "../../context/PracticeContext";
import { useRoot } from "../../context/RootContext";
import useStateRef from "react-usestateref";
import { useTutor } from "../../context/AiTutorContext";
import {
  AnimatedCount,
  EmptyCardsDescription,
  EmptyCardsTitle } from
"./TaskScreenHelper";
import { TaskScreenStyles } from "./TaskScreenStyles";
import { StorageService } from "../../utils/StorageUtils";
import TaskCardSkeleton from "../../components/molecules/SkeletonViews/TaskScreenSkeleton";
import MobileTaskCardSkeleton from "../../components/molecules/SkeletonViews/MobileTaskScreenSkeleton";
import SubjectFilterComponent from "./SubjectFilterComponent";
import CompletedTaskBox from "./CompletedTaskBox";
import ForbiddenLayout from "../../components/molecules/errorLayouts/ForbiddenLayout";
import {
  getUserDetails,
  postKakfaEventForDemoRun,
  redirectToLoginPage } from
"../../api/login-service";
import { getCookie, removeCookie, setCookie } from "../../utils/TutorConstants";
import { backUpObjectCreation } from "../../utils/accordion/accordionHelper";
import TaskScreenTour from "./TaskScreenTour";
import WelcomeModal from "../../components/molecules/modal/WelcomeModal";
import MobileWelcomeModal from "../../components/molecules/modal/MobileWelcomeModal";
import DemoOnBoarding from "../demo/DemoOnBoarding";
import * as Sentry from "@sentry/remix";
import { sendScopedException, sendCustomEvent } from "../../utils/sentry";

const cardProp = {
  category: "Assessment",
  title: "Definition and effect of force",
  finishedDate: "5 Mar",
  borderColor: RESOURCES.colors.CORNFLOWER_BLUE,
  backgroundColor: RESOURCES.colors.LAVANDER_PINOCCHIO,
  titleColor: RESOURCES.colors.CORNFLOWER_BLUE
};
const FILTER_OPTIONS = {
  topPriority: {
    name: "Upcoming",
    value: "top_priority"
  },
  missedOpportunity: {
    name: "Overdue",
    value: "missed_opportunity"
  },
  completed: {
    name: "Completed",
    value: "completed"
  }
};

const TaskScreen = ({ emailTaskProgressId = "", emailUserId = "" }) => {
  const [startTaskIndex, setStartTaskIndex] = useState(0);
  const cardsToShow = 4;
  const endTaskIndex = startTaskIndex + cardsToShow;

  const {
    setIsHome,
    setJourneyId,
    setTaskStepId,
    setGrade,
    setSubject,
    journeyId,
    setTopicMasterUuid,
    setSubjectMasterUUid,
    setSelectedSubTopic
  } = useTutor();
  const navigate = useNavigate();
  const [taskStatus, setTaskStatus] = useState("");
  const [displayLearn, setDisplayLearn, displayLearnRef] = useStateRef(false);
  const [displayExperiential, setDisplayExperiential] = useState(false);
  const [experientialData, setExperientialData] = useState({});
  const [taskData, setTaskData] = useState([]);
  const [filteredTaskData, setFilteredTaskData] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("All");
  const [
  userAdditionalDetails,
  setUserAdditionalDetails,
  userAdditionalDetailsRef] =
  useStateRef({});
  const [showTaskCardModal, setShowTaskCardModal] = useState(false);
  const [customAssessmentList, setCustomAssesmentList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [onMenuClickFromModal, setOnMenuClickFromModal] = useState(false);
  const [updatesData, setUpdatesData] = useState(null);
  const [emotionalMessage, setEmotionalMessage] = useState(0);
  const [currentOptionValue, setCurrentOptionValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(
    FILTER_OPTIONS.topPriority
  );
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [isMenuOpen, setIsMenuOpen, isMenuOpenRef] = useStateRef(false);
  const [overdueCount, setOverdueCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [completeSubjectList, setCompleteSubjectList] = useState([]);
  const [subjectNamesList, setsubjectNamesList] = useState([]);
  const [overdueTaskList, setOverdueTaskList] = useState([]);
  const [overdueCustomAssessmentList, setOverdueCustomAssesmentList] =
  useState(null);
  const [hasHydrated, setHasHydrated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showForbiddenLayout, setShowForbiddenLayout, showForbiddenLayoutRef] =
  useStateRef(false);
  const [isDemoRun, setIsDemoRun, isDemoRunRef] = useStateRef(false);
  const {
    userDetails,
    setTaskTypeName,
    setTopicName,
    setSubTopicName,
    setTaskCatagory,
    setSubjectName,
    setReviewScreen,
    isReviewScreen,
    handleTakeupNextTask,
    setIsExperientialLearning,
    setSelectedIndex,
    setTaskId,
    setTaskType,
    isUpdatesDisplayed,
    setIsDiscussFlow,
    displayProductTour
  } = useRoot();
  const toast = useToast();
  const location = useLocation();
  const { startProductTour = false } = location.state || {};
  const { setSelectedJourney, buttons } = usePractice();
  const latestRequestRef = useRef(0);
  useEffect(() => {
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    setUserAdditionalDetails(details);
    setIsModalOpen(startProductTour);
    setIsHome(true);
    if (location.state) {
      window.history.replaceState(null, "", window.location.href);
    }
  }, []);

  useEffect(() => {
    // if (isNotEmptyOrNull(userAdditionalDetailsRef.current)) {
    const isDemo = getCookie("IsDemo") === "true";
    setIsDemoRun(isUpdatesDisplayed ? false : isDemo);
    // }
  }, [userAdditionalDetailsRef.current, isUpdatesDisplayed]);

  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false
  });

  const displayedTasks = isMobile ?
  filteredTaskData :
  filteredTaskData?.slice(startTaskIndex, endTaskIndex);

  useEffect(() => {
    const handleEmailTaskProgress = async () => {
      if (isNotEmptyOrNull(emailTaskProgressId)) {
        if (emailUserId === userDetails?.data?.studentId) {
          await callStartTask(emailTaskProgressId);
        } else {
          setShowForbiddenLayout(true);
          removeCookie("taskProgressId");
          setTimeout(() => {
            redirectToLoginPage();
          }, [2000]);
        }
      }
    };

    handleEmailTaskProgress();
  }, [emailTaskProgressId]);

  const editor = () => {
    return (
      <PlainInput
        isDisable={true}
        buttons={buttons}
        hideFormula={true}
        onMenuToggle={onMenuClickFromModal}
        handleReviewNavigate={isReviewScreen}
        openMenu={isMenuOpenRef.current} />);


  };

  useEffect(() => {
    editor();
  }, [displayProductTour]);

  const getTaskList = async (filterOption) => {
    const requestId = Date.now();
    latestRequestRef.current = requestId;
    try {
      setIsLoading(true);
      const taskDataRespose = await getALlTasks(filterOption);
      if (latestRequestRef.current === requestId) {
        if (taskDataRespose.success) {
          setTaskData(taskDataRespose.data.data);
          setFilteredTaskData(taskDataRespose?.data?.data);
          setCustomAssesmentList(
            taskDataRespose.data.data.filter(
              (task) => task?.taskAttributes?.customSubtopicsAssessment === true
            )
          );
        }
        setIsLoading(false);
      }
    } catch (error) {
      if (latestRequestRef.current === requestId) {
        setIsLoading(false);
      }
      console.error(error);
    }
  };

  const getOverdueTaskList = async (filterOption) => {
    try {
      setIsLoading(true);
      const taskDataResponse = await getALlTasks(filterOption);
      if (taskDataResponse?.success) {
        setOverdueTaskList(taskDataResponse?.data?.data);
        setOverdueCustomAssesmentList(
          taskDataResponse.data.data.filter(
            (task) => task?.taskAttributes?.customSubtopicsAssessment === true
          )
        );
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(err);
    }
  };

  const getRequiredTopic = (subjectMasterUuid, topicMasterUuid) => {
    const neededSubject = completeSubjectList?.find((subject) => {
      return subject?.master_uuid === subjectMasterUuid;
    });
    const matchingTopic = neededSubject?.topicDetails.find(
      (topicDetail) => topicDetail?.topic?.topicMasterUuid === topicMasterUuid
    );
    return matchingTopic;
  };

  const getEmotionalMessages = async () => {
    const response = await getRandomVinMessage(15);
    if (response?.data?.message && response?.data?.status === true) {
      return response.data.message;
    } else {
      return "These are the updates from your school today";
    }
  };

  const schoolUpdatesMessage = async () => {
    let message = await getEmotionalMessages();
    setEmotionalMessage(message);
  };

  const handleTaskClick = (
  id,
  taskIds,
  topicName,
  grade,
  subjectName,
  journeyId,
  taskStatus,
  subjectId,
  experientialLearning,
  taskType,
  subTopic) =>
  {
    const topicSelected = getRequiredTopic(
      subjectId,
      subTopic?.taskAttributes?.topicMasterUuid
    );
    setSelectedJourney(journeyId);
    setTaskId(id);
    subjectName ? setSubjectName(subjectName) : setSubjectName(topicName);
    let backUpObject = backUpObjectCreation(subTopic);
    StorageService.setItem("backUpObject", backUpObject);
    if (isNotEmptyOrNull(experientialLearning)) {
      if (isNotEmptyOrNull(experientialLearning?.activityInfo)) {
        setExperientialData(experientialLearning);
        setIsExperientialLearning(true);
        setDisplayExperiential(true);
        navigate(`${urlString}/experiential`, {
          state: {
            experientialLearningData: experientialLearning,
            postId: subTopic?.postId,
            selectedItem: subTopic
          }
        });
      } else {
        callStartTask(id, topicName, grade, subjectName);
      }
      //getTopicFromSectionSyllabus(subjectId, topicName);
      setReviewScreen(false);
    } else if (taskStatus == "completed") {
      setSelectedSubTopic(subTopic);
      setJourneyId(journeyId);
      setReviewScreen(true);
      StorageService.setItem("ReviewJourneyId", journeyId);
      StorageService.setItem("topicName", topicName || "");
      StorageService.setItem("subjectName", subjectName || "");
      StorageService.setItem(
        "subTopicName",
        subTopic?.taskAttributes?.subtopicName || ""
      );
      StorageService.setItem("subjectMasterUUid", subTopic?.subjectId);
      StorageService.setItem(
        "topicMasterUUid",
        subTopic?.taskAttributes?.topicMasterUuid
      );
      navigate(`${urlString}/review`, {
        state: {
          // journeyId: journeyId || "",

          subjectMasterUuid: subTopic?.subjectId || "",
          topicMasterUuid: subTopic?.taskAttributes?.topicMasterUuid || ""
        }
      });
    } else {
      if (taskType === taskTypes.assessment) {
        navigate(`${urlString}/assessment`, {
          state: {
            selectedSubTopic: subTopic,
            selectedTopic: topicSelected
          }
        });
      } else {
        navigate(`${urlString}/practice`, {
          state: {
            selectedSubTopic: subTopic,
            selectedTopic: topicSelected
          }
        });
      }
      setReviewScreen(false);
      // getTopicFromSectionSyllabus(subjectId, topicName);
    }
  };

  useEffect(() => {
    if (!isUpdatesDisplayed) {
      // handleOptionClick(selectedOption);
      getTaskList(selectedOption.value);
      getTaskCount();
      getSubjectList();
      getOverdueTaskList("missed_opportunity");
    }

    setDisplayLearn(false);
    if (isUpdatesDisplayed) {
      schoolUpdatesMessage();
    }
  }, [handleTakeupNextTask, isUpdatesDisplayed]);

  const callStartTask = async (id, grade, subjectName) => {
    try {
      const response = await startTask(id);
      if (response?.success) {
        const { success, data } = response;
        if (
        isNotEmptyOrNull(data?.data?.taskAttributes?.experientialLearning))
        {
          setJourneyId(data?.data?.journeyId);
          setTaskStepId(data?.data?.stepId);
          setGrade(grade ? grade : "");
          setSubject(subjectName ? subjectName : "");
          setExperientialData(data?.data?.taskAttributes?.experientialLearning);
          setDisplayExperiential(true);
          if (data?.data?.taskStatus === "completed") {
            navigate(`${urlString}/wall/wall-detailed-page`, {
              state: {
                postTaskData: data?.data
              }
            });
          } else {
            navigate(`${urlString}/experiential`, {
              state: {
                experientialLearningData:
                data?.data?.taskAttributes?.experientialLearning,
                postId: data?.data?.postId,
                selectedItem: data?.data
              } // add post Id here
            });
          }
        } else {
          let updatedBackUp = StorageService.getItem("backUpObject");
          updatedBackUp = {
            ...updatedBackUp,
            journeyId: data?.data?.journeyId
          };
          StorageService.setItem("backUpObject", updatedBackUp);
          handleTaskClick(
            data?.data?._id,
            data?.data?.taskId,
            data?.data?.taskAttributes?.topicName,
            data?.data?.taskAttributes?.gradeName,
            data?.data?.taskAttributes?.subjectName,
            data?.data?.journeyId,
            data?.data?.taskStatus,
            data?.data?.subjectId,
            data?.data?.taskAttributes?.experientialLearning,
            data?.data?.taskType,
            data?.data
          );
        }
      } else {
        if (
        response?.statusCode == 403 &&
        isNotEmptyOrNull(emailTaskProgressId))
        {
          // sentry email trigger error
          sendCustomEvent(
            "Email trigger",
            "error",
            {
              data: data?.data
            },
            ["email", id, new Date().toISOString()]
          );

          setShowForbiddenLayout(true);
          removeCookie("taskProgressId");
          setTimeout(() => {
            redirectToLoginPage();
          }, [2000]);
        } else {
          removeCookie("taskProgressId");
          // sentry data.data

          sendCustomEvent(
            "Failed to start homework",
            "error",
            {
              data: data?.data
            },
            ["failed_homework", id, new Date().toISOString()]
          );

          toast({
            description: "Failed to start Homework",
            position: "top",
            status: status.error,
            duration: 1000,
            isClosable: true,
            containerStyle: {
              color: "#fff"
            }
          });
        }
        setSubTopicName("");
        setTopicName("");
        setSubjectName("");
        setTaskCatagory("");
      }
    } catch (error) {
      removeCookie("taskProgressId");
      console.log("ERROR here", error);
      error.name = "Failed to start Homework";
      sendScopedException(
        error,
        ["Failed to start Homework", id, new Date().toISOString()],
        { homework: "failed homework" },
        {
          data: JSON.stringify(data?.data, null, 2),
          id: JSON.stringify(id, null, 2)
        }
      );
    }
  };

  const getTaskCount = async () => {
    try {
      const taskCountResponse = await getTaskCountAPI();
      if (taskCountResponse.status) {
        setUpcomingCount(taskCountResponse?.data?.top_priority);
        setOverdueCount(taskCountResponse?.data?.missed_opportunity);
        setCompletedCount(taskCountResponse?.data?.completed);
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const getSubjectList = async () => {
    try {
      setIsLoading(true);
      // console.log(
      //   "userAdditionalDetailsRef",
      //   userAdditionalDetailsRef?.current
      // );
      let payload = {
        schoolId: userAdditionalDetailsRef?.current?.schoolId,
        gradeId: userAdditionalDetailsRef?.current?.schoolGradeId,
        sectionId: userAdditionalDetailsRef?.current?.sectionId,
        academicYearId: userAdditionalDetailsRef?.current?.academicYearId
      };
      if (getCookie("IsDemo") === "true") {
        fetchUserDetails();
      } else {
        subjectListingV3(payload);
      }
    } catch (e) {
      setIsLoading(false);
      console.error("Failed to load subject data", e);
    }
  };

  const fetchUserDetails = async () => {
    let details = StorageService.getItem("user_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    let { success, data } = await getUserDetails(
      details?.userId ?? details?._id,
      details?.registrationStatus
    );
    if (success) {
      StorageService.setItem("user_additional_details", data?.data);
      let payload = {
        schoolId: data?.data?.schoolId,
        gradeId: data?.data?.schoolGradeId,
        sectionId: data?.data?.sectionId,
        academicYearId: data?.data?.academicYearId
      };
      subjectListingV3(payload);
    }
  };

  const subjectListingV3 = async (payload) => {
    const {
      latestTasks: latesttasks,
      subjects: fetchedSubjects,
      customSubtopicTopics: customsubtopictopics
    } = await getSectionSubjectTreeV3(payload);
    let subjectNames = fetchedSubjects?.map((subject) => subject?.name);
    setsubjectNamesList(subjectNames);
    setCompleteSubjectList(fetchedSubjects);
    setIsLoading(false);
  };

  const handleOptionClick = (option) => {
    if (selectedOption?.value === option?.value) {
      return;
    }
    setSelectedOption(option);
    getTaskList(option.value);
    setTaskTypeName(option.name);
    setStartTaskIndex(0);
    setCurrentOptionValue(option.value);
    setSelectedSubject("All");
  };
  useEffect(() => {
    setIsDiscussFlow(false);
  }, []);

  const handleNextTaskCard = () => {
    if (endTaskIndex < filteredTaskData?.length) {
      setStartTaskIndex(startTaskIndex + cardsToShow);
    }
  };

  const handlePreviousTaskCard = () => {
    if (startTaskIndex > 0) {
      setStartTaskIndex(startTaskIndex - cardsToShow);
    }
  };

  const saveDemoKafkaEvents = async (data) => {
    let details = await StorageService.getItem("user_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    let userId = isNotEmptyOrNull(userAdditionalDetailsRef.current) ?
    userAdditionalDetailsRef.current?.studentId :
    details?.userId;
    let postData = {
      user_id: userId,
      data: {
        event_name: "demo-run-user-interactions",
        userType: "student",
        browser_fingerprint: getCookie("fingerprint"),
        user_agent: window?.navigator?.userAgent,
        referrrel_url: getCookie("StudentRef") || "direct_access",
        visited_tabs: data
      }
    };
    await postKakfaEventForDemoRun(postData);
  };

  const handleDemoItemClick = (taskType) => {
    // console.log("Raghavendra", taskType);
    let filterType = "";
    switch (taskType) {
      case "GP":
        filterType = "guidedPractise";
        setSelectedIndex(4);
        break;
      case "AP":
        filterType = "assessment";
        setSelectedIndex(5);
        break;
      case "Learn":
        filterType = "learnSubtopic";
        setSelectedIndex(1);
        break;
    }

    let item = filteredTaskData.find((task) => task.taskType === filterType);
    if (isEmptyOrNull(item)) {
      item = overdueTaskList.find((task) => task.taskType === filterType);
    }

    if (isNotEmptyOrNull(item)) {
      handleTaskClick(
        item?._id,
        item?.taskId,
        item?.taskAttributes?.topicName,
        item?.taskAttributes?.gradeName,
        item?.taskAttributes?.subjectName,
        item?.journeyId,
        item?.taskStatus,
        item?.subjectId,
        item?.taskAttributes?.experientialLearning,
        item?.taskType,
        item
      );
      setSubTopicName(item?.taskAttributes?.subtopicName);
      setTopicName(item?.taskAttributes?.topicName);
      setSubject(item?.taskAttributes?.subjectName);
      setTaskCatagory(item?.taskType);
      setSubjectMasterUUid(item?.subjectId);
      setTopicMasterUuid(item?.taskAttributes?.topicMasterUuid);
      const existingCookie = getCookie("selectedDemoItems");
      let selectedDemo = existingCookie ? JSON.parse(existingCookie) : [];
      if (!selectedDemo.includes(taskType)) {
        selectedDemo = [...selectedDemo, taskType];
      }
      saveDemoKafkaEvents(JSON.stringify(selectedDemo));
      setCookie("selectedDemoItems", JSON.stringify(selectedDemo));
    } else {
      alert("Task not available");
    }
  };

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  if (
  !hasHydrated ||
  isNotEmptyOrNull(emailTaskProgressId) && !showForbiddenLayoutRef?.current)
  {
    return null;
  }

  const handleStep4 = (open, isLastStep) => {
    setIsMenuOpen(open);
  };

  return (
    <>
      {showForbiddenLayoutRef?.current && <ForbiddenLayout />}
      {!isLoading && displayProductTour &&
      <TaskScreenTour
        onStep5={handleStep4}
        taskDataLength={displayedTasks?.length}
        tourdata={
        displayedTasks?.length > 0 ? taskTourData : taskTourDataWithoutTasks
        } />

      }
      <Box
        sx={TaskScreenStyles()?.mainContainer}
        style={displayProductTour ? { pointerEvents: "none" } : {}}>

        <Box sx={TaskScreenStyles()?.subContainer}>
          <Flex sx={TaskScreenStyles()?.subbContainer}>
            {!isMobile &&
            <Box sx={TaskScreenStyles()?.vinImage}>
                <img
                className={styles["assistant-img-tasks"]}
                src={AssistantImg}
                alt="assistant"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain"
                }} />

              </Box>
            }
            <Box sx={TaskScreenStyles()?.rightContainer}>
              <Box sx={TaskScreenStyles()?.rightTopContainer}>
                {isMobile &&
                <Lottie
                  loop
                  animationData={HomeLottie}
                  play
                  style={{
                    width: "200px",
                    height: "178px"
                  }} />

                }
                <Box sx={TaskScreenStyles()?.userGreetings}>
                  {userAdditionalDetailsRef?.current?.firstName &&
                  <div>
                      <Text sx={TaskScreenStyles()?.userName}>
                        {`Hello, ${
                      isNotEmptyOrNull(userDetails?.firstName) ?
                      userDetails?.firstName :
                      userAdditionalDetailsRef?.current?.firstName ?
                      userAdditionalDetailsRef?.current?.firstName :
                      ""}!`
                      }
                      </Text>
                      <Text sx={TaskScreenStyles()?.userMessage}>
                        {isUpdatesDisplayed ?
                      updatesData ?
                      String(emotionalMessage).
                      split("@@linebreak").
                      map((line, index) =>
                      <React.Fragment key={index}>
                                    {line}
                                    {index <
                        String(emotionalMessage).split(
                          "@@linebreak"
                        ).length -
                        1 && <br />}
                                  </React.Fragment>
                      ) :
                      `No updates from your school today, but stay tuned for more !` :
                      `I organised your homework for you, ready to give them a go?`}
                      </Text>
                    </div>
                  }
                </Box>
                {!isUpdatesDisplayed &&
                <Box sx={TaskScreenStyles()?.optionContainer}>
                    <HStack sx={TaskScreenStyles(isMobile)?.subOptionContainer}>
                      {Object.values(FILTER_OPTIONS).map((option) =>
                    <WrapItem
                      key={`filterOption-${option.name}`}
                      sx={TaskScreenStyles()?.wrapContainer}>

                          <Button
                        data-filter={option.value}
                        sx={
                        selectedOption.name === option.name ?
                        {
                          ...TaskScreenStyles()?.baseButton,
                          ...TaskScreenStyles()?.activeButton
                        } :
                        {
                          ...TaskScreenStyles()?.baseButton,
                          ...TaskScreenStyles()?.passiveButton
                        }
                        }
                        onClick={() => handleOptionClick(option)}>

                            <Box sx={TaskScreenStyles()?.buttonContainer}>
                              <Text
                            sx={
                            selectedOption === option ?
                            {
                              ...TaskScreenStyles()?.baseButtonText,
                              ...TaskScreenStyles()?.buttonTextActive
                            } :
                            {
                              ...TaskScreenStyles()?.baseButtonText,
                              ...TaskScreenStyles()?.
                              buttonTextPassive
                            }
                            }>

                                {option.name}
                              </Text>
                              <Text
                            sx={{
                              ...TaskScreenStyles().baseButtonCount,
                              ...(option.value === "top_priority" ?
                              TaskScreenStyles()?.upcomingButtonCount :
                              option.value === "missed_opportunity" ?
                              TaskScreenStyles()?.overdueButtonCount :
                              TaskScreenStyles()?.completedButtonCount)
                            }}>

                                {option.value === "top_priority" ?
                            <AnimatedCount count={upcomingCount} /> :
                            option.value === "missed_opportunity" ?
                            <AnimatedCount count={overdueCount} /> :

                            <AnimatedCount count={completedCount} />
                            }
                              </Text>
                            </Box>
                          </Button>
                        </WrapItem>
                    )}
                    </HStack>
                  </Box>
                }
              </Box>
              {isLoading ?
              isMobile ?
              <MobileTaskCardSkeleton /> :

              <TaskCardSkeleton count={4} /> :


              filteredTaskData?.length > 0 &&
              !isUpdatesDisplayed &&
              !isLoading &&
              <Box sx={TaskScreenStyles()?.taskCardContainer}>
                    <HStack sx={TaskScreenStyles()?.taskCardSubContainer}>
                      <Box sx={TaskScreenStyles()?.taskCardSubbContainer}>
                        <Box>
                          {displayedTasks?.length > 0 &&
                      <Box>
                              <VStack sx={TaskScreenStyles()?.taskCardSection}>
                                {!isMobile &&
                          <Text
                            sx={
                            TaskScreenStyles()?.
                            optionTitleTaskCardSection
                            }>

                                    {selectedOption.name}
                                  </Text>
                          }
                                {isNotEmptyOrNull(subjectNamesList) &&
                          <Box
                            sx={TaskScreenStyles()?.subjectFilterParent}>

                                    <SubjectFilterComponent
                              subjectList={subjectNamesList}
                              taskData={taskData}
                              setFilteredTaskData={setFilteredTaskData}
                              selectedSubject={selectedSubject}
                              setSelectedSubject={setSelectedSubject}
                              setStartTaskIndex={setStartTaskIndex} />

                                  </Box>
                          }
                                <Wrap
                            id={"cardsData"}
                            sx={TaskScreenStyles()?.taskCardWrapContainer}>

                                  {displayedTasks?.map((task, index) => {
                              const i = index;
                              const id = task?._id;
                              const title =
                              task?.taskAttributes?.topicName || "";
                              const subjectName =
                              task?.taskAttributes?.subjectName || "";
                              const finishedDate = task?.taskStatus || "";
                              const category = capitalize(
                                task?.taskType || ""
                              );
                              const dueDate = task?.dueDate;
                              const completedOn = task?.endedAt;
                              const subTopicName =
                              task?.taskAttributes?.subtopicName || "";
                              const topicName =
                              task?.taskAttributes?.topicName || "";
                              const reminder = task?.reminder;
                              const isChapterEndAssessment =
                              task?.taskAttributes?.
                              chapterEndAssessment || false;

                              const levelUpNudge = task?.levelUp;
                              const levelUpReference =
                              task?.levelUpReference;
                              const autoLevelUp = task?.autoLevelUp;
                              const appreciation = task?.appreciation;
                              const proficientLevel = capitalize(
                                task?.taskAttributes?.proficiencyLevel ||
                                ""
                              );
                              const experientialLearning =
                              task?.taskAttributes?.
                              experientialLearning || {};
                              const isCustomAssessment =
                              task?.taskAttributes?.
                              customSubtopicsAssessment || false;

                              const customAssessmentSubtopic =
                              customAssessmentList?.find(
                                (item) => item._id === id
                              );

                              const assignedDate = task?.createdAt;

                              const taskselectedname =
                              selectedOption.name;

                              return (
                                <WrapItem
                                  key={`taskcard-${title}${id}`}
                                  sx={
                                  TaskScreenStyles()?.cardSuperContainer
                                  }>

                                        {isMobile ?
                                  <MobileTaskCard
                                    onClick={() => {
                                      if (
                                      isNotEmptyOrNull(
                                        task?.taskAttributes?.
                                        experientialLearning
                                      ) &&
                                      task?.taskStatus === "completed")
                                      {
                                        navigate(
                                          `${urlString}/wall/wall-detailed-page`,
                                          {
                                            state: {
                                              postTaskData: task
                                            }
                                          }
                                        );
                                      } else {
                                        console.log(task);
                                        setTaskType(task?.taskType);
                                        let taskType = task?.taskType;
                                        if (
                                        taskType === "LearnSubTopic")
                                        {
                                          setSelectedIndex(1);
                                        } else if (
                                        taskType === "GuidedPractise")
                                        {
                                          setSelectedIndex(4);
                                        } else if (
                                        taskType === "Assessment")
                                        {
                                          setSelectedIndex(5);
                                        }
                                        handleTaskClick(
                                          task?._id,
                                          task?.taskId,
                                          task?.taskAttributes?.
                                          topicName,
                                          task?.taskAttributes?.
                                          gradeName,
                                          task?.taskAttributes?.
                                          subjectName,
                                          task?.journeyId,
                                          task?.taskStatus,
                                          task?.subjectId,
                                          task?.taskAttributes?.
                                          experientialLearning,
                                          task?.taskType,
                                          task
                                        );
                                        setSubTopicName(
                                          task?.taskAttributes?.
                                          subtopicName
                                        );
                                        setTopicName(
                                          task?.taskAttributes?.
                                          topicName
                                        );
                                        setSubject(
                                          task?.taskAttributes?.
                                          subjectName
                                        );
                                        setTaskCatagory(task?.taskType);
                                        setSubjectMasterUUid(
                                          task?.subjectId
                                        );
                                        setTopicMasterUuid(
                                          task?.taskAttributes?.
                                          topicMasterUuid
                                        );
                                      }
                                    }}
                                    cardData={{
                                      ...cardProp,
                                      id,
                                      title,
                                      finishedDate,
                                      subjectName,
                                      category,
                                      completedOn,
                                      dueDate,
                                      subTopicName,
                                      topicName,
                                      reminder,
                                      levelUpNudge,
                                      appreciation,
                                      isChapterEndAssessment,
                                      proficientLevel,
                                      experientialLearning,
                                      levelUpReference,
                                      autoLevelUp,
                                      isCustomAssessment,
                                      selectedOption,
                                      ...(customAssessmentSubtopic ?
                                      { customAssessmentSubtopic } :
                                      {}),
                                      assignedDate
                                    }} /> :


                                  <TaskCard
                                    id={`taskcard-${taskselectedname}-${index}`}
                                    onClick={() => {
                                      if (
                                      isNotEmptyOrNull(
                                        task?.taskAttributes?.
                                        experientialLearning
                                      ) &&
                                      task?.taskStatus === "completed")
                                      {
                                        navigate(
                                          `${urlString}/wall/wall-detailed-page`,
                                          {
                                            state: {
                                              postTaskData: task
                                            }
                                          }
                                        );
                                      } else {
                                        console.log(task);
                                        setTaskType(task?.taskType);
                                        let taskType = task?.taskType;
                                        if (
                                        taskType === "LearnSubTopic")
                                        {
                                          setSelectedIndex(1);
                                        } else if (
                                        taskType === "GuidedPractise")
                                        {
                                          setSelectedIndex(4);
                                        } else if (
                                        taskType === "Assessment")
                                        {
                                          setSelectedIndex(5);
                                        }
                                        handleTaskClick(
                                          task?._id,
                                          task?.taskId,
                                          task?.taskAttributes?.
                                          topicName,
                                          task?.taskAttributes?.
                                          gradeName,
                                          task?.taskAttributes?.
                                          subjectName,
                                          task?.journeyId,
                                          task?.taskStatus,
                                          task?.subjectId,
                                          task?.taskAttributes?.
                                          experientialLearning,
                                          task?.taskType,
                                          task
                                        );
                                        setSubTopicName(
                                          task?.taskAttributes?.
                                          subtopicName
                                        );
                                        setTopicName(
                                          task?.taskAttributes?.
                                          topicName
                                        );
                                        setSubject(
                                          task?.taskAttributes?.
                                          subjectName
                                        );
                                        setTaskCatagory(task?.taskType);
                                        setSubjectMasterUUid(
                                          task?.subjectId
                                        );
                                        setTopicMasterUuid(
                                          task?.taskAttributes?.
                                          topicMasterUuid
                                        );
                                      }
                                    }}
                                    cardData={{
                                      ...cardProp,
                                      id,
                                      taskselectedname,
                                      i,
                                      title,
                                      finishedDate,
                                      subjectName,
                                      category,
                                      completedOn,
                                      dueDate,
                                      subTopicName,
                                      topicName,
                                      reminder,
                                      levelUpNudge,
                                      appreciation,
                                      isChapterEndAssessment,
                                      proficientLevel,
                                      experientialLearning,
                                      levelUpReference,
                                      autoLevelUp,
                                      isCustomAssessment,
                                      selectedOption,
                                      ...(customAssessmentSubtopic ?
                                      { customAssessmentSubtopic } :
                                      {}),
                                      assignedDate
                                    }} />

                                  }
                                      </WrapItem>);

                            })}
                                </Wrap>
                              </VStack>
                            </Box>
                      }
                        </Box>
                        {!isMobile &&
                    <PaginationComponent
                      currentPage={Math.ceil((startTaskIndex + 1) / 4)}
                      totalPages={Math.ceil(filteredTaskData?.length / 4)}
                      handleNextTaskCard={handleNextTaskCard}
                      handlePreviousTaskCard={handlePreviousTaskCard}
                      disableNext={
                      endTaskIndex >= filteredTaskData?.length ||
                      filteredTaskData?.length < 3
                      }
                      disablePrevious={startTaskIndex === 0} />

                    }
                      </Box>
                    </HStack>
                  </Box>

              }
              {/* EMPTY TASK CONTAINER */}
              {filteredTaskData?.length === 0 &&
              !isUpdatesDisplayed &&
              !isLoading &&
              <Box sx={TaskScreenStyles()?.emptyTasksMainContainer}>
                    {!isMobile &&
                <Text sx={TaskScreenStyles()?.optionTitleTaskCardSection}>
                        {selectedOption.name}
                      </Text>
                }
                    {isNotEmptyOrNull(subjectNamesList) &&
                <Box sx={TaskScreenStyles()?.subjectFilterParent} pt={2}>
                        <SubjectFilterComponent
                    subjectList={subjectNamesList}
                    taskData={taskData}
                    setFilteredTaskData={setFilteredTaskData}
                    selectedSubject={selectedSubject}
                    setSelectedSubject={setSelectedSubject}
                    setStartTaskIndex={setStartTaskIndex} />

                      </Box>
                }
                    <Box
                  id="noTasks"
                  sx={TaskScreenStyles()?.emptyTasksContainer}>

                      <Image
                    src={accordion_images.noUpdates}
                    width={"200px"}
                    height={"150px"} />

                      <Box sx={TaskScreenStyles()?.emptyTasksContainerTitle}>
                        {EmptyCardsTitle(currentOptionValue)}
                      </Box>
                      <Box
                    sx={TaskScreenStyles()?.emptyTasksContainerDescription}>

                        {EmptyCardsDescription(currentOptionValue)}
                      </Box>
                    </Box>
                  </Box>
              }
              {/* SCHOOL UPDATES */}
              {isUpdatesDisplayed && !isLoading &&
              <SchoolUpdatesPresenter
                handleTaskClick={handleTaskClick}
                setTaskType={setTaskType}
                setSubTopicName={setSubTopicName}
                setTopicName={setTopicName}
                setTaskCatagory={setTaskCatagory}
                setSelectedIndex={setSelectedIndex}
                setSubject={setSubject}
                setSubjectMasterUUid={setSubjectMasterUUid}
                setTopicMasterUuid={setTopicMasterUuid}
                setUpdates={setUpdatesData} />

              }
              {/* DISPLAY OVERDUE BOX */}
              {!isMobile &&
              selectedOption?.name === "Upcoming" &&
              !isUpdatesDisplayed &&
              overdueTaskList?.length > 0 &&
              <Box sx={TaskScreenStyles()?.taskCardContainer}>
                    <HStack sx={TaskScreenStyles()?.taskCardSubContainer}>
                      <Box sx={TaskScreenStyles()?.taskCardSubbContainer}>
                        <Box>
                          <Box>
                            <VStack sx={TaskScreenStyles()?.taskCardSection}>
                              {!isMobile &&
                          <Text
                            sx={
                            TaskScreenStyles()?.
                            optionTitleTaskCardSection
                            }>

                                  Overdue
                                </Text>
                          }
                              <Wrap
                            sx={TaskScreenStyles()?.taskCardWrapContainer}>

                                {overdueTaskList?.
                            slice(0, 2).
                            map((task, index) => {
                              const i = index;
                              const id = task?._id;
                              const title =
                              task?.taskAttributes?.topicName || "";
                              const subjectName =
                              task?.taskAttributes?.subjectName || "";
                              const finishedDate = task?.taskStatus || "";
                              const category = capitalize(
                                task?.taskType || ""
                              );
                              const dueDate = task?.dueDate;
                              const completedOn = task?.endedAt;
                              const subTopicName =
                              task?.taskAttributes?.subtopicName || "";
                              const topicName =
                              task?.taskAttributes?.topicName || "";
                              const reminder = task?.reminder;
                              const isChapterEndAssessment =
                              task?.taskAttributes?.
                              chapterEndAssessment || false;

                              const levelUpNudge = task?.levelUp;
                              const levelUpReference =
                              task?.levelUpReference;
                              const autoLevelUp = task?.autoLevelUp;
                              const appreciation = task?.appreciation;
                              const proficientLevel = capitalize(
                                task?.taskAttributes?.proficiencyLevel ||
                                ""
                              );
                              const experientialLearning =
                              task?.taskAttributes?.
                              experientialLearning || {};
                              const isCustomAssessment =
                              task?.taskAttributes?.
                              customSubtopicsAssessment || false;

                              const customAssessmentSubtopic =
                              overdueCustomAssessmentList?.find(
                                (item) => item._id === id
                              );

                              const assignedDate = task?.createdAt;
                              const taskselectedname = "Overdue";
                              return (
                                <WrapItem
                                  key={`taskcard-${title}${id}`}
                                  sx={
                                  TaskScreenStyles()?.cardSuperContainer
                                  }>

                                        {
                                  <TaskCard
                                    onClick={() => {
                                      if (
                                      isNotEmptyOrNull(
                                        task?.taskAttributes?.
                                        experientialLearning
                                      ) &&
                                      task?.taskStatus === "completed")
                                      {
                                        navigate(
                                          `${urlString}/wall/wall-detailed-page`,
                                          {
                                            state: {
                                              postTaskData: task
                                            }
                                          }
                                        );
                                      } else {
                                        console.log(task);
                                        setTaskType(task?.taskType);
                                        let taskType = task?.taskType;
                                        if (
                                        taskType === "LearnSubTopic")
                                        {
                                          setSelectedIndex(1);
                                        } else if (
                                        taskType === "GuidedPractise")
                                        {
                                          setSelectedIndex(4);
                                        } else if (
                                        taskType === "Assessment")
                                        {
                                          setSelectedIndex(5);
                                        }
                                        handleTaskClick(
                                          task?._id,
                                          task?.taskId,
                                          task?.taskAttributes?.
                                          topicName,
                                          task?.taskAttributes?.
                                          gradeName,
                                          task?.taskAttributes?.
                                          subjectName,
                                          task?.journeyId,
                                          task?.taskStatus,
                                          task?.subjectId,
                                          task?.taskAttributes?.
                                          experientialLearning,
                                          task?.taskType,
                                          task
                                        );
                                        setSubTopicName(
                                          task?.taskAttributes?.
                                          subtopicName
                                        );
                                        setTopicName(
                                          task?.taskAttributes?.
                                          topicName
                                        );
                                        setSubject(
                                          task?.taskAttributes?.
                                          subjectName
                                        );
                                        setTaskCatagory(task?.taskType);
                                        setSubjectMasterUUid(
                                          task?.subjectId
                                        );
                                        setTopicMasterUuid(
                                          task?.taskAttributes?.
                                          topicMasterUuid
                                        );
                                      }
                                    }}
                                    cardData={{
                                      ...cardProp,
                                      id,
                                      i,
                                      taskselectedname,
                                      title,
                                      finishedDate,
                                      subjectName,
                                      category,
                                      completedOn,
                                      dueDate,
                                      subTopicName,
                                      topicName,
                                      reminder,
                                      levelUpNudge,
                                      appreciation,
                                      isChapterEndAssessment,
                                      proficientLevel,
                                      experientialLearning,
                                      levelUpReference,
                                      autoLevelUp,
                                      isCustomAssessment,
                                      selectedOption,
                                      ...(customAssessmentSubtopic ?
                                      { customAssessmentSubtopic } :
                                      {}),
                                      assignedDate
                                    }} />

                                  }
                                      </WrapItem>);

                            })}
                              </Wrap>
                            </VStack>
                          </Box>
                        </Box>
                        <Box
                      onClick={() => {
                        handleOptionClick({
                          name: "Overdue",
                          value: "missed_opportunity"
                        });
                      }}
                      sx={TaskScreenStyles()?.overdueBottomBox}>

                          <Text sx={TaskScreenStyles()?.overdueBottomBoxText}>
                            See All
                          </Text>
                        </Box>
                      </Box>
                    </HStack>
                  </Box>
              }
              {/* DISPLAY COMPLETED BOX */}
              {!isMobile &&
              selectedOption?.name === "Upcoming" &&
              !isUpdatesDisplayed &&
              !isLoading &&
              <CompletedTaskBox
                handleOptionClick={handleOptionClick}
                count={completedCount} />

              }
            </Box>
          </Flex>
        </Box>

        {/* PLAIN INPUT */}
        {!showForbiddenLayoutRef?.current &&
        <Box sx={TaskScreenStyles(isMobile)?.bottomInput}>
            {editor()}
            <Box sx={TaskScreenStyles()?.bottomBox}></Box>
          </Box>
        }
      </Box>
      {isMobile ?
      <MobileWelcomeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        name={
        isNotEmptyOrNull(userDetails?.firstName) ?
        userDetails?.firstName :
        userAdditionalDetailsRef?.current?.firstName ?
        userAdditionalDetailsRef?.current?.firstName :
        ""
        } /> :


      <WelcomeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        name={
        isNotEmptyOrNull(userDetails?.firstName) ?
        userDetails?.firstName :
        userAdditionalDetailsRef?.current?.firstName ?
        userAdditionalDetailsRef?.current?.firstName :
        ""
        } />

      }
      <DemoOnBoarding
        isOpen={isDemoRunRef.current}
        onClose={!isDemoRunRef.current}
        handleDemoItemClick={handleDemoItemClick}
        handleCloseDemoClick={() => {
          saveDemoKafkaEvents("Continue Exploring");
          setIsDemoRun(false);
        }} />

    </>);

};

export default TaskScreen;